export type CanalTermo = 'sms' | 'email';

export const ERRO_CELULAR = 'Celular com DDD: 11 dígitos, começando com 9 depois do DDD.';
export const ERRO_EMAIL = 'E-mail inválido.';

/** Só os dígitos do celular válido (DDD + 9 + 8 dígitos), ou null. */
export function validarCelular(valor: string): string | null {
  const d = (valor ?? '').replace(/\D/g, '');
  return d.length === 11 && d[2] === '9' ? d : null;
}

/** E-mail em minúsculas, ou null. */
export function validarEmail(valor: string): string | null {
  const v = (valor ?? '').trim();
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v) ? v.toLowerCase() : null;
}

// Completo de propósito: o operador confere com o paciente para onde o termo vai.
export function formatarDestino(canal: CanalTermo, destino: string): string {
  if (canal === 'email') return destino;
  const d = (destino ?? '').replace(/\D/g, '');
  if (d.length === 11) return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
  if (d.length === 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return destino;
}
